<template>
  <div class="container" :style="{ height: height }">
    <div>
      <div>
        <div class="title">任务说明</div>
        <div class="addBox">
          <el-input
            type="textarea"
            v-model="addDescriptionValue"
            :rows="5"
            class="textarea"
            maxlength="20"
          ></el-input>
          <div>
            <el-button
              type="primary"
              class="addBtn"
              size="small"
              icon="el-icon-plus"
              @click="addTask(1)"
            ></el-button>
          </div>
        </div>
        <div class="contentBox">
          <div class="content">
            <div
              v-for="(item, index) in taskDescription"
              :key="item"
              :class="activeDescriptionIndex === index ? 'active' : ''"
              @click="changeIndex1(index)"
            >
              {{ item }}
            </div>
          </div>
          <div class="btnBox">
            <el-button
              type="danger"
              size="small"
              icon="el-icon-minus"
              @click="del1"
            ></el-button>
            <el-button
              type="info"
              size="small"
              icon="el-icon-top"
              plain
              @click="top1"
              :disabled="activeDescriptionIndex == 0"
            ></el-button>
            <el-button
              type="info"
              size="small"
              icon="el-icon-bottom"
              plain
              @click="bottom1"
              :disabled="activeDescriptionIndex == taskDescription.length - 1"
            ></el-button>
          </div>
        </div>
      </div>
      <div>
        <div class="title">任务要求</div>
        <div class="addBox">
          <el-input
            type="textarea"
            v-model="addRequirementValue"
            :rows="5"
            class="textarea"
            maxlength="20"
          ></el-input>
          <div>
            <el-button
              type="primary"
              class="addBtn"
              size="small"
              icon="el-icon-plus"
              @click="addTask(2)"
            ></el-button>
          </div>
        </div>
        <div class="contentBox">
          <div class="content">
            <div
              v-for="(item, index) in taskRequirements"
              :key="item"
              :class="activeRequirementsIndex === index ? 'active' : ''"
              @click="changeIndex2(index)"
            >
              {{ item }}
            </div>
          </div>
          <div class="btnBox">
            <el-button
              @click="del2"
              type="danger"
              size="small"
              icon="el-icon-minus"
            ></el-button>
            <el-button
              type="info"
              size="small"
              icon="el-icon-top"
              plain
              @click="top2"
              :disabled="activeRequirementsIndex == 0"
            ></el-button>
            <el-button
              type="info"
              size="small"
              icon="el-icon-bottom"
              plain
              @click="bottom2"
              :disabled="activeRequirementsIndex == taskRequirements.length - 1"
            ></el-button>
          </div>
        </div>
      </div>
    </div>
    <el-button type="primary" v-loading.fullscreen.lock="loading" @click="submit" >提交保存</el-button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      addDescriptionValue: "",
      addRequirementValue: "",
      height: "600px",
      taskDescription: [],
      taskRequirements: [],
      activeDescriptionIndex: -9999,
      activeRequirementsIndex: -9999,
      loading:false
    };
  },
  methods: {
    getDataList() {
      this.$http({
        method: "GET",
        url: "/rest/PublishedWork/searchTaskDescriptionRequirements?type=1",
      }).then((res) => {
        this.taskDescription = res.data;
      });
      this.$http({
        method: "GET",
        url: "/rest/PublishedWork/searchTaskDescriptionRequirements?type=2",
      }).then((res) => {
        this.taskRequirements = res.data;
      });
    },
    //add
    addTask(type) {
      let flag = true;
      if (type === 1) {
        this.taskDescription.forEach((item) => {
          if (item == this.addDescriptionValue.trim()) {
            flag = false;
            this.$message({
              message: "该任务已经存在",
              type: "warning",
            });
          }
          if (this.addDescriptionValue.trim() == "") {
            flag = false;
            this.$message({
              message: "不能输入空字符",
              type: "warning",
            });
          }
          if (this.addDescriptionValue.includes(";")) {
            flag = false;
            this.$message({
              message: "不能输入分号`;`",
              type: "warning",
            });
          }
        });
        if (flag) {
          this.taskDescription = [
            this.addDescriptionValue,
            ...this.taskDescription,
          ];
          this.addDescriptionValue = "";
        }
      }
      if (type === 2) {
        this.taskRequirements.forEach((item) => {
          if (item == this.addRequirementValue.trim()) {
            flag = false;
            this.$message({
              message: "该任务已经存在",
              type: "warning",
            });
          }
          if (this.addRequirementValue.trim() == "") {
            flag = false;
            this.$message({
              message: "不能输入空字符",
              type: "warning",
            });
          }
          if (this.addRequirementValue.includes(";")) {
            flag = false;
            this.$message({
              message: "不能输入分号`;`",
              type: "warning",
            });
          }
        });
        if (flag) {
          this.taskRequirements = [
            this.addRequirementValue,
            ...this.taskRequirements,
          ];
          this.addRequirementValue = "";
        }
      }
    },
    // 改变选中状态
    changeIndex1(index) {
      this.activeDescriptionIndex = index;
    },
    changeIndex2(index) {
      this.activeRequirementsIndex = index;
    },
    //删除
    del1() {
      this.taskDescription.splice(this.activeDescriptionIndex, 1);
      this.activeDescriptionIndex = -9999;
    },
    del2() {
      this.taskRequirements.splice(this.activeRequirementsIndex, 1);
      this.activeRequirementsIndex = -9999;
    },
    top1() {
      let keep = this.taskDescription
        .splice(this.activeDescriptionIndex, 1)
        .join();
      console.log(keep);
      this.taskDescription.splice(this.activeDescriptionIndex - 1, 0, keep);
      this.activeDescriptionIndex--;
    },
    top2() {
      let keep = this.taskRequirements
        .splice(this.activeRequirementsIndex, 1)
        .join();
      console.log(keep);
      this.taskRequirements.splice(this.activeRequirementsIndex - 1, 0, keep);
      this.activeRequirementsIndex--;
    },
    bottom1() {
      let keep = this.taskDescription
        .splice(this.activeDescriptionIndex, 1)
        .join();
      console.log(keep);
      this.taskDescription.splice(this.activeDescriptionIndex + 1, 0, keep);
      this.activeDescriptionIndex++;
    },
    bottom2() {
      let keep = this.taskRequirements
        .splice(this.activeRequirementsIndex, 1)
        .join();
      console.log(keep);
      this.taskRequirements.splice(this.activeRequirementsIndex + 1, 0, keep);
      this.activeRequirementsIndex++;
    },
    submit() {
      this.loading=true
      this.$http
        .post("/rest/PublishedWork/saveTaskDescriptionRequirements", [
          {
            workSignType: 1,
            workSignName: this.taskDescription,
          },
          {
            workSignType: 2,
            workSignName: this.taskRequirements,
          },
        ])
        .then((res) => {
          if (res.data.code == 0) {
            this.$notify({
            title: '提示',
            message: '保存成功',
            type: 'success',
            dangerouslyUseHTMLString: true
          })
          }
          this.loading=false
        })
        .catch(()=>{
          this.loading=false
        })
    },
  },
  mounted() {
    this.height = window.screen.height - 290 + "px";
    this.getDataList();
  },
};
</script>
<style lang="scss" scoped>
.container {
  height: 100%;
  background: #fff;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  > div {
    width: 100%;
    display: flex;
    justify-content: space-around;
    > div {
      width: 28%;
    }
  }
}
.title {
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  margin-bottom: 5px;
}
.addBox {
  display: flex;
  margin-bottom: 20px;
  .textarea {
    width: 100%;
  }
  .addBtn {
    margin-left: 10px;
  }
}
.contentBox {
  display: flex;
  margin-bottom: 60px;
  .content {
    overflow: auto;
    font-size: 14px;
    border: 1px solid #ccc;
    width: 100%;
    height: 400px;
    > div {
      height: 25px;
      line-height: 25px;
      cursor: pointer;
      padding: 0 5px;
    }
    .active {
      background: #0099ff;
      color: #fff;
    }
  }
  .btnBox {
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    button {
      margin-left: 0px;
      margin-bottom: 10px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/workSquare/PublishTaskConfiguration.vue